var map = {
	"./en.json": [
		3394,
		7
	],
	"./es-CO.json": [
		3395,
		8
	],
	"./fr.json": [
		3396,
		9
	],
	"./ko.json": [
		3397,
		10
	],
	"./pt-BR.json": [
		3398,
		11
	],
	"./th.json": [
		3399,
		12
	],
	"./vi.json": [
		3400,
		13
	],
	"./zh-CN.json": [
		3401,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2105;
module.exports = webpackAsyncContext;